import React from 'react';
import { Box, Grid, Skeleton, Stack } from '@mui/material';

export const StatCardsSkeleton: React.FC<{ count?: number }> = ({ count = 4 }) => (
  <Grid container spacing={2}>
    {Array.from({ length: count }).map((_, i) => (
      <Grid key={i} item xs={6} md={3}>
        <Box sx={{ p: 2.25, border: '1px solid rgba(7,24,45,0.08)', borderRadius: 1 }}>
          <Skeleton width={28} height={28} variant="rectangular" sx={{ borderRadius: 1, mb: 1 }} />
          <Skeleton width="60%" height={14} />
          <Skeleton width="80%" height={40} sx={{ mt: 0.5 }} />
          <Skeleton width="50%" height={12} sx={{ mt: 0.5 }} />
        </Box>
      </Grid>
    ))}
  </Grid>
);

export const ListItemSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
  <Stack divider={<Box sx={{ borderBottom: '1px solid rgba(7,24,45,0.06)' }} />}>
    {Array.from({ length: rows }).map((_, i) => (
      <Box key={i} p={2.25}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <Skeleton width="30%" height={20} />
            <Skeleton width="80%" height={22} sx={{ mt: 0.5 }} />
            <Skeleton width="60%" height={14} sx={{ mt: 0.5 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Skeleton width="70%" height={16} />
            <Skeleton width="50%" height={14} sx={{ mt: 0.5 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack direction="row" spacing={1} justifyContent={{ md: 'flex-end' }}>
              <Skeleton width={80} height={32} variant="rectangular" sx={{ borderRadius: 1 }} />
              <Skeleton width={80} height={32} variant="rectangular" sx={{ borderRadius: 1 }} />
            </Stack>
          </Grid>
        </Grid>
      </Box>
    ))}
  </Stack>
);

export const HeroBannerSkeleton: React.FC = () => (
  <Skeleton variant="rectangular" height={120} sx={{ borderRadius: 1 }} />
);

export const CardRowSkeleton: React.FC<{ cols?: number }> = ({ cols = 2 }) => (
  <Grid container spacing={2.5}>
    {Array.from({ length: cols }).map((_, i) => (
      <Grid key={i} item xs={12} md={12 / cols}>
        <Box sx={{ p: 2.5, border: '1px solid rgba(7,24,45,0.08)', borderRadius: 1, height: 180 }}>
          <Skeleton width="50%" height={22} />
          <Skeleton width="30%" height={14} sx={{ mt: 0.5 }} />
          <Skeleton variant="rectangular" height={8} sx={{ borderRadius: 4, mt: 2 }} />
          <Skeleton width="40%" height={12} sx={{ mt: 1 }} />
        </Box>
      </Grid>
    ))}
  </Grid>
);
